import {createReducer} from '../../base/fsa/createReducer';
import {UserState} from './state';
import {clearUserAction, setUserAction} from './action';

export const initialUserState: UserState = {
    username: 'default',
    password: 'default',
};

export const userReducer = createReducer(initialUserState,
    handle => [
        handle(setUserAction, (state, action) => {
            return {
                ...state,
                username: action.payload.username,
                password: action.payload.password,
            };
        }),
        handle(clearUserAction, (state) => {
            return {
                ...initialUserState,
            };
        }),
    ],
);
